import { render, staticRenderFns } from "./DentalSvg.vue?vue&type=template&id=6ae3f15f&scoped=true&"
import script from "./DentalSvg.js?vue&type=script&lang=js&"
export * from "./DentalSvg.js?vue&type=script&lang=js&"
import style0 from "./DentalSvg.vue?vue&type=style&index=0&id=6ae3f15f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae3f15f",
  null
  
)

export default component.exports